<template>
	<div class="static-page">
		<div class="static-header">
			<span class="back" @click="goBack">← 返回</span>
			<h1 class="title">{{ pageTitle }}</h1>
		</div>
		<div class="static-body">
			<div class="rich-text" v-html="content" v-if="!loading && content"></div>
			<div class="loading-state" v-if="loading">加载中...</div>
			<div class="empty-state" v-if="!loading && !content">暂无内容</div>
		</div>
	</div>
</template>

<script>
	import { getSetting } from '@/api/public'

	export default {
		name: 'StaticPage',
		data() {
			return {
				content: '',
				loading: false
			}
		},
		computed: {
			pageType() {
				return this.$route.name === 'Agreement' ? 'agreement' : 'privacy'
			},
			pageTitle() {
				return this.pageType === 'agreement' ? '用户协议' : '隐私政策'
			}
		},
		created() {
			this.fetchContent()
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			async fetchContent() {
				const key = this.pageType === 'agreement' ? 'user' : 'secret'
				this.loading = true
				try {
					const res = await getSetting({ groupKey: key })
					this.content = this.pageType === 'agreement' ? (res.user || '') : (res.secret || '')
				} catch (e) {
					console.error(e)
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped>
	.static-page {
		min-height: calc(100vh - 60px);
		background: #1a1a1a;
		color: #fff;
		padding: 24px;
	}
	.static-header {
		max-width: 800px;
		margin: 0 auto 24px;
		position: relative;
	}
	.static-header .back {
		color: #FE8E04;
		cursor: pointer;
		font-size: 14px;
	}
	.static-header .back:hover {
		text-decoration: underline;
	}
	.static-header .title {
		font-size: 22px;
		margin: 16px 0 0;
		text-align: center;
	}
	.static-body {
		max-width: 800px;
		margin: 0 auto;
		line-height: 1.6;
	}
	.rich-text :deep(img) {
		max-width: 100%;
		height: auto;
	}
	.loading-state,
	.empty-state {
		text-align: center;
		color: #999;
		padding: 40px 0;
	}
</style>
